import React, {useEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom';
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.css'
import {TbMailbox} from 'react-icons/tb';
import {GiHandTruck} from "react-icons/gi";
import {BsPersonCheckFill} from "react-icons/bs";
import Waiting from "../Chapas_Norte_Elementor_Widget_Component/loading";
import {GoAlert} from "react-icons/go";
import "./Chapas_Norte_Cantos_DHL_Elementor_Widget.css";

export default function Chapas_Norte_Cantos_DHL_Elementor_Widget() {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') || '';
    const [searchTerm, setSearchTerm] = useState(id);
    const [loading, setLoading] = useState(true);
    const formRef = useRef(null);
    const apiUrl = '/wp-json';
    const url = `${apiUrl}/chapas-norte/dhl/track-trace`;

    //setings
    const element = document.getElementById('chapas_norte_cantos_dhl_elementor_widget');
    const inputplaceholder = element.dataset.inputPlaceholder;
    const paragraphvalue = element.dataset.parValue;

    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };

    useEffect(() => {
        if (id && formRef.current) {
            setSearchTerm(id);
            axios
                .get(url, {
                    params: {
                        id: id
                    }
                })
                .then((res) => {
                    setLoading(true);
                    ReactDOM.render(
                        <TrackingData data={res.data}/>, document.getElementById('insidezone2'));
                })
                .catch((err) => {
                    setLoading(true);
                    ReactDOM.render(
                        <TrackingData data={err}/>, document.getElementById('insidezone2'));
                });
        }
    }, [id]);

    function handleClick(e) {
        e.preventDefault();

        setLoading(false);
        ReactDOM.render(<div></div>, document.getElementById('insidezone2'));

        axios
            .get(url, {
                params: {
                    id: searchTerm
                }
            })
            .then((res) => {
                setLoading(true);
                ReactDOM.render(
                    <TrackingData data={res.data}/>, document.getElementById('insidezone2'));
            })
            .catch((err) => {
                setLoading(true);
                ReactDOM.render(
                    <TrackingData data={err}/>, document.getElementById('insidezone2'));
            });
    }

    //randerizar elementos de la lista de dhl
    function RenderListItem(item) {
        if (item.Code === 'R') {
            return <li key={item.DateTime} className="d-flex no-block card-body elementor-list-widget-list-item li-dhl">
                <TbMailbox className={"plugin-icons"}/>
                <div className={"item-text"}>
                    <span className="m-b-0 p-0 elementor-list-widget-list-text">
                        {item.Status} {item.Ubication}
                    </span>
                    <span className="text-muted">
                        <p>{item.DateTime}</p>
                    </span>
                </div>
            </li>
        } else if (item.Code === 'T') {
            return <li key={item.DateTime} className="d-flex no-block card-body elementor-list-widget-list-item li-dhl">
                <GiHandTruck className={"plugin-icons"}/>
                <div className={"item-text"}>
                    <span className="m-b-0 p-0 elementor-list-widget-list-text">
                        {item.Status} {item.Ubication}
                    </span>
                    <span className="text-muted">
                        <p>{item.DateTime}</p>
                    </span>
                </div>
            </li>;
        } else if (item.Code === 'A') {
            return <li key={item.DateTime} className="d-flex no-block card-body elementor-list-widget-list-item li-dhl">
                <BsPersonCheckFill className={"plugin-icons"}/>
                <div className={"item-text"}>
                    <span className="m-b-0 p-0 elementor-list-widget-list-text">
                        {item.Status} {item.Ubication}
                    </span>
                    <span className="text-muted">
                        <p>{item.DateTime}</p>
                    </span>
                </div>
            </li>;
        }
    }

    //componenete a randerizar post axios
    function TrackingData(props) {
        try {
            const dataArray = JSON.parse(props.data);

            const htmlContent = dataArray.map((item) => {
                return RenderListItem(item);
            });

            return (
                <div className="row d-flex justify-content-center mt-100 mb-100">
                    <div className="col-lg-6">
                        <div className="card">
                            <ul className={"elementor-list-widget-list-item"}>
                                {htmlContent}
                            </ul>
                        </div>
                    </div>
                </div>
            );
        } catch (e) {
            return (
                <div className="alert alert-danger d-flex align-items-center elementor-list-widget-alert-error"
                     role="alert">
                    <GoAlert/>
                    <div className="ms-2 elementor-list-widget-text-alert elementor-list-widget-alert-error-text">
                        An error has occurred, please try again later.
                    </div>
                </div>
            );
        }
    }

    return (
        <div>
            <form ref={formRef} onSubmit={(e) => handleClick(e)}>
                <p className="elementor-list-widget-text elementor-list-widget-text-pa">{paragraphvalue}</p>
                <div className={"d-flex align-items-center"}>
                    <div className="input-group mb-3 elementor-list-widget-text">
                        <input type="text" className="form-control elementor-list-widget-input" value={searchTerm}
                               onChange={handleChange} placeholder={inputplaceholder} disabled={!loading}
                               aria-describedby="button-addon2"/>
                        <button className="btn btn-outline-secondary elementor-list-widget-button" type="button"
                                id="button-addon2" onClick={handleClick} disabled={!loading}>
                            <Waiting id="x" hidden={loading}/>
                            Search
                        </button>
                    </div>
                </div>
            </form>

            <div className="mt-3" id={"insidezone2"}></div>
        </div>
    );
}